import {useEffect, useState} from 'react'
import {Card, Col, Row, Collapse, Button} from 'react-bootstrap'
import {ITagCreate} from '../../interface/tag'
import {FormikProps, useFormik} from 'formik'
import TextField from '../../components/TextField'
import {IDiscipline} from '../../interface/discipline/discipline'
import {GetDisciplineByPlantService} from '../../service/discipline.service/discipline'
import {
  GetTagTypeByDisciplineService,
  GetTagTypeByTagPropertyService,
} from '../../service/tag-type.service'
import Select from '../../components/Select'
import {ITagType} from '../../interface/tag-type'
import ButtonComp from '../../components/Button'
import * as Yup from 'yup'
import {CreateTagService} from '../../service/tag.service'
import Swal from 'sweetalert2'
import {DEFAULT_ERROR_MODAL, DEFAULT_SUCCESS_MODAL} from '../../constants/errors/error-model'
import {useNavigate} from 'react-router-dom'
import {IPlant} from '../../interface/plant/plant'
import {GetPlantByCompanyService} from '../../service/plant.service/plant.service'
import {useUserSelector} from '../../store/user'
import {useCompanyGroupSelector} from '../../store/companyGroup'
import {GetCompanybyCompanyGroupIdService} from '../../service/company.service'
import {IPageOption} from '../../interface/paging/paging'
import {ICompany} from '../../interface/company/company'
import {DEFAULT_CORMFIRM_MODAL} from '../../constants/swal'

type ValueMapping = {
  value: string
  segmentText: string
}

type Config = {
  attributeTypeId: string
  dataType: 'number' | 'string'
  isPrefix: boolean
  segmentNo: number
  valueMaps: ValueMapping[]
}

type TagTypeAffixConfig = {
  prefix: string
  runningStart: string
  runningEnd: string
}

type ArrangAttributeType = {
  value: string
  attributeTypeId: string
  dataType: 'number' | 'string'
  isPrefix: boolean
  segmentNo: number
  valueMaps: {
    value: string
    segmentText: string
  }[]
}

const initialValues: ITagCreate = {
  companyGroupId: '',
  companyGroupName: '',
  companyId: '',
  plantId: '',
  disciplineId: '',
  tagTypeId: '',
  code: '',
  name: '',
  isActive: true,
  attributeGroups: [],
}
const tagSchema = Yup.object().shape({
  tagTypeId: Yup.string().required('Tag Type is required'),
  name: Yup.string().required('Tag Description is required'),
  code: Yup.string().required('Tag Number is required'),
})

const RegisterTagDetail = (props) => {
  const {user, isSuperAdmin, isUser, myCompany} = useUserSelector()
  const {companyGroup} = useCompanyGroupSelector()

  const navigate = useNavigate()
  const [disciplines, setDisciplines] = useState<IDiscipline[]>()
  const [attribute, setAttribute] = useState<any[]>([])
  const [tagTypesList, setTagTypesList] = useState<ITagType[]>()
  const [plants, setPlants] = useState<IPlant[]>()
  const [companies, setCompanies] = useState<ICompany[]>([])
  const [attrTypeAffixMap, setAttrTypeAffixMap] = useState<Map<string, Config>>()
  const [existedTagCodeSet, setExistedTagCodeSet] = useState<Set<string>>()
  const [tagTypePrefixConfig, setTagTypePrefixConfig] = useState<TagTypeAffixConfig>()
  const [isAutoGenerateTagCode, setIsAutoGenerateTagCode] = useState<boolean>(false)

  const formik: FormikProps<ITagCreate> = useFormik({
    initialValues,
    validationSchema: tagSchema,
    onSubmit: (values, {setSubmitting}) => {
      setSubmitting(true)
      let isInvalid = false
      const temp = values.attributeGroups.map((el) => {
        return {
          ...el,
          attributeTypes: el.attributeTypes.map((item) => {
            if (item.isRequired && !item.value) {
              isInvalid = true
              return {
                ...item,
                isInvalid: true,
              }
            } else {
              return {
                ...item,
              }
            }
          }),
        }
      }) as any
      formik.values.attributeGroups = [...temp]
      setAttribute([...temp])

      if (isInvalid) {
        setSubmitting(false)
        return
      }
      Swal.fire(DEFAULT_CORMFIRM_MODAL(`Do you want to <br/>Register New Tag?`)).then((result) => {
        if (result.isConfirmed) {
          const params = {
            name: values.name,
            code: values.code,
            isActive: true,
            tagTypeId: values.tagTypeId,
            attributeGroups: values.attributeGroups.map((el) => {
              return {
                id: el.id,
                attributes: el.attributeTypes.map((item) => {
                  return {
                    attributeTypeId: item.id,
                    value: item.value || null,
                  }
                }),
              }
            }),
          }
          createTag(params as any)
            .then(async (res: any) => {
              await Swal.fire(DEFAULT_SUCCESS_MODAL('Register New Tag Success!'))
              setSubmitting(false)
              console.log('create tag', res)
              if (props.isAssignTag) {
                props.hanedleAddTag(res.data.tagId)
              } else {
                navigate('/browse-tag')
              }
            })
            .catch((err) => {
              Swal.fire(DEFAULT_ERROR_MODAL(err?.response?.data?.message || err.message))
              setSubmitting(false)
            })
        } else {
          setSubmitting(false)
        }
      })
    },
  })

  useEffect(() => {
    if (!props.taskDetail?.values?.plantId) return
    getDisciplinesByPlantId(props.taskDetail.values.plantId)
  }, [])

  useEffect(() => {
    if (!user || isSuperAdmin) return
    formik.setFieldValue('companyGroupId', user?.companyGroup?.id)
    if (isUser && myCompany && user) {
      formik.setFieldValue('companyId', myCompany.company.id)
    }
  }, [user])

  useEffect(() => {
    if (!formik.values.companyGroupId || !isSuperAdmin) return
    getCompanyByCompanyGroupId(formik.values.companyGroupId)
  }, [formik?.values?.companyGroupId])

  useEffect(() => {
    if (!formik.values.companyId) {
      setPlants([])
      return
    }
    console.log('formik.values.companyId', formik.values.companyId)

    getPlants(formik.values.companyId as string).then((res) => {
      setPlants(res)
    })
  }, [formik?.values?.companyId])

  useEffect(() => {
    formik.setFieldValue('disciplineId', '')
    formik.setFieldValue('tagTypeId', '')
    setDisciplines([])
    setTagTypesList([])

    if (!formik.values.plantId) return
    getDisciplinesByPlantId(formik.values.plantId)
  }, [formik.values.plantId])

  useEffect(() => {
    formik.setFieldValue('tagTypeId', '')
    setTagTypesList([])

    if (!formik.values.disciplineId) return
    getTagTypeByDisciplineId(formik.values.disciplineId)
  }, [formik.values.disciplineId])

  useEffect(() => {
    if (!formik.values.tagTypeId) return
    getAttributeByTagTypeId(formik.values.tagTypeId)
  }, [formik.values.tagTypeId])

  const getCompanyByCompanyGroupId = async (id: string) => {
    const params = {
      getOnlyActive: true,
    } as IPageOption
    const getCompanyService = new GetCompanybyCompanyGroupIdService()
    const _companies = await getCompanyService.request(params, id)
    await setCompanies(_companies.data ? _companies.data : _companies)
  }

  const createTag = async (payload: ITagCreate) => {
    const createTagTypeService = new CreateTagService()
    return await createTagTypeService.request(payload)
  }

  const getPlants = async (id: string) => {
    const getPlantService = new GetPlantByCompanyService()
    const _plants = await getPlantService.request(id)
    return _plants
  }
  const getDisciplinesByPlantId = async (plantId: string) => {
    const getDisciplineService = new GetDisciplineByPlantService()
    const _disciplines = await getDisciplineService.request(plantId)
    setDisciplines(_disciplines.data)
  }
  const getTagTypeByDisciplineId = async (disciplineId: string) => {
    const getDisciplineService = new GetTagTypeByDisciplineService()
    const _tagType = await getDisciplineService.request(disciplineId)
    setTagTypesList(_tagType.data)
  }
  const getAttributeByTagTypeId = async (tagTypeId: string) => {
    //reset code
    formik.setFieldValue('code', '')

    const getAttributeByTagTypeIdService = new GetTagTypeByTagPropertyService()
    const _res = await getAttributeByTagTypeIdService.request(tagTypeId)
    console.log('_res', _res.attributeGroups)
    formik.values.attributeGroups = [..._res.attributeGroups]
    for (let i in _res.attributeGroups) {
      _res.attributeGroups[i].isOpen = false
      for (let j in _res.attributeGroups[i].attributeTypes) {
        _res.attributeGroups[i].attributeTypes[j].value = ''
      }
    }

    const attrTypeAffixMap = new Map<string, Config>()
    _res.attributeTypeAffixConfig.forEach((e) => attrTypeAffixMap.set(e.attributeTypeId, e))

    setAttribute(_res.attributeGroups)
    setAttrTypeAffixMap(attrTypeAffixMap)
    setTagTypePrefixConfig(_res.tagTypeAffixConfig)
    setIsAutoGenerateTagCode(_res.isAutoGenerateTagCode)
    setExistedTagCodeSet(new Set(_res.existedTagCodes || []))
  }

  const generatePrefix = (data: ArrangAttributeType[]) => {
    let res = tagTypePrefixConfig?.prefix || ''
    data.forEach((e) => {
      let affix = ''
      const isNumber = e.dataType == 'number'
      let defaultMapping: ValueMapping | null = null

      for (const map of e.valueMaps) {
        if (map.value == 'default') defaultMapping = map
        else {
          const configVal = !isNumber ? map.value : +map.value
          const attrVal = e.value == '' ? undefined : !isNumber ? e.value : +e.value

          if (configVal == attrVal) {
            affix = map.segmentText
            break
          }
        }
      }

      res += !!affix ? affix : defaultMapping?.segmentText || ''
    })

    return res
  }

  const generatePostfix = (data: ArrangAttributeType[]) => {
    let res = ``
    data.forEach((e) => {
      let affix = ''
      const isNumber = e.dataType == 'number'
      let defaultMapping: ValueMapping | null = null

      for (const map of e.valueMaps) {
        if (map.value == 'default') defaultMapping = map
        else {
          const configVal = !isNumber ? map.value : +map.value
          const attrVal = e.value == '' ? undefined : !isNumber ? e.value : +e.value

          if (configVal == attrVal) {
            affix = map.segmentText
            break
          }
        }
      }

      res += !!affix ? affix : defaultMapping?.segmentText || ''
    })

    return res
  }

  const arrangedAttributeType = () => {
    const result: {prefixConfig: ArrangAttributeType[]; postfixConfig: ArrangAttributeType[]} = {
      prefixConfig: [],
      postfixConfig: [],
    }

    formik.values.attributeGroups?.forEach((attrGroup) => {
      attrGroup.attributeTypes?.forEach((attrType) => {
        const config = attrTypeAffixMap?.get(attrType.id)
        if (!config) return

        const data = {...config, value: attrType.value}
        if (config.isPrefix) result.prefixConfig.push(data)
        else result.postfixConfig.push(data)
      })
    })

    result.prefixConfig.sort((a, b) => a.segmentNo - b.segmentNo)
    result.postfixConfig.sort((a, b) => a.segmentNo - b.segmentNo)

    return result
  }

  const tagCodeBuilder = () => {
    const arrangedAttributes = arrangedAttributeType()

    const prefix = generatePrefix(arrangedAttributes.prefixConfig)
    const postfix = generatePostfix(arrangedAttributes.postfixConfig)
    const segmentLength = tagTypePrefixConfig?.runningStart?.length || 0
    let runningNumber = +(tagTypePrefixConfig?.runningStart || 0)
    const runningEnd = +(tagTypePrefixConfig?.runningEnd || 0)

    let result = ''
    do {
      if (runningEnd < runningNumber) {
        throw Error(`Auto-running number is over limit, ${runningEnd}`)
      }

      const runningNumberString = runningNumber.toString().padStart(segmentLength, '0')
      //update tag number
      result = `${prefix}${runningNumberString}${postfix}`

      runningNumber += 1
    } while (existedTagCodeSet?.has(result) || false)

    formik.setFieldValue('code', result)
  }

  return (
    <>
      <Card>
        <Card.Body>
          <form onSubmit={formik.handleSubmit} noValidate>
            {!props.isAssignTag && (
              <h1 className='mb-5'>{'AIMS-TAG > Register New Tag > Register'}</h1>
            )}

            <Row>
              {props.taskDetail ? (
                <></>
              ) : (
                <Col xs={12} sm={6} md={{span: 3}}>
                  <>
                    <Select
                      required
                      formik={formik}
                      name={'companyGroupId'}
                      label='Company Group'
                      option={companyGroup.data || []}
                      keyLabel='name'
                      keyValue='id'
                      disabled={!isSuperAdmin}
                    />
                  </>
                </Col>
              )}
              <Col xs={12} sm={6} md={{span: 3}}>
                {props.taskDetail ? (
                  <>
                    <TextField disabled formik={props.taskDetail} name={'company'} label='Plant' />
                  </>
                ) : (
                  <>
                    {isSuperAdmin ? (
                      <Select
                        required
                        formik={formik}
                        name={'companyId'}
                        label='Company'
                        option={companies || []}
                        keyLabel='name'
                        keyValue='id'
                        disabled={isUser}
                      />
                    ) : (
                      <Select
                        required
                        isCompany
                        formik={formik}
                        name={'companyId'}
                        label='Company'
                        option={user?.companies || []}
                        keyLabel='name'
                        keyValue='id'
                        disabled={isUser}
                      />
                    )}
                  </>
                )}
              </Col>
              <Col xs={12} sm={6} md={{span: 3}}>
                {props.taskDetail ? (
                  <>
                    <TextField disabled formik={props.taskDetail} name={'plant'} label='Plant' />
                  </>
                ) : (
                  <>
                    <Select
                      required
                      formik={formik}
                      name={'plantId'}
                      label='Plant'
                      option={plants || []}
                      keyLabel='name'
                      keyValue='id'
                    />
                  </>
                )}
              </Col>
              <Col xs={12} sm={6} md={{span: 3}}>
                <Select
                  required
                  formik={formik}
                  name={'disciplineId'}
                  label='Discipline'
                  option={disciplines || []}
                  keyLabel='name'
                  keyValue='id'
                />
              </Col>
              <Col xs={12} sm={6} md={{span: 3}}>
                <Select
                  required
                  formik={formik}
                  name={'tagTypeId'}
                  label='Tag Type'
                  option={tagTypesList || []}
                  keyLabel='name'
                  keyValue='id'
                />
              </Col>
              <Col xs={12} sm={6} md={{span: 3}}>
                <TextField required formik={formik} name={'code'} label='Tag Number' isCode />
              </Col>
              <Col xs={12} sm={6} md={{span: 3}}>
                <TextField required formik={formik} name={'name'} label='Tag Description' isName />
              </Col>
            </Row>

            <hr className='mt-10' />
            <Row>
              {attribute.map((item, i) => {
                return (
                  <div key={i}>
                    <Row>
                      <Col xs={12} className='mt-3'>
                        <div
                          onClick={() => {
                            attribute[i].isOpen = !attribute[i].isOpen
                            setAttribute([...attribute])
                          }}
                          aria-controls='example-collapse-text'
                          aria-expanded={item.isOpen}
                          style={{display: 'flex', justifyContent: 'space-between'}}
                        >
                          <h1>{item.name}</h1>
                          <i
                            className='bi bi-chevron-down'
                            style={{fontSize: 20, paddingRight: 40}}
                          ></i>
                        </div>
                      </Col>
                      <Col>
                        <Collapse in={item.isOpen}>
                          <Row>
                            {item.attributeTypes.map((el, j) => {
                              return (
                                <Col xs={12} sm={6} md={{span: 4, offset: 1}} key={j}>
                                  <TextField
                                    required={el.isRequired}
                                    formik={formik}
                                    name={`attributeGroups.${i}.attributeTypes.${j}.value`}
                                    label={`${
                                      el.uom ? `${el.name} (${el.uom.unit})` : `${el.name}`
                                    }`}
                                    type={el.type}
                                    isInvalid={
                                      el.isRequired &&
                                      !formik.values.attributeGroups[i]?.attributeTypes[j]?.value &&
                                      (el.isInvalid || formik.submitCount > 0)
                                    }
                                  />
                                </Col>
                              )
                            })}
                          </Row>
                        </Collapse>
                      </Col>
                    </Row>
                    <hr className='mt-3' />
                  </div>
                )
              })}
            </Row>
            <Row>
              <Col xs={12} className='mt-3 d-flex justify-content-end mb-3'>
                <ButtonComp
                  type='button'
                  variant='primary'
                  onClick={tagCodeBuilder}
                  disabled={!isAutoGenerateTagCode}
                  doing={formik.isSubmitting}
                >
                  Generate Tag Number
                </ButtonComp>

                <ButtonComp type='submit' variant='primary' doing={formik.isSubmitting}>
                  Create
                </ButtonComp>
              </Col>
            </Row>
          </form>
        </Card.Body>
      </Card>
    </>
  )
}

export default RegisterTagDetail
